import React from 'react';

import { styled } from '@mui/material/styles';

type BadgeColor = 'primary' | 'warning' | 'error' | 'success' | 'info' | 'gray';

interface KitBadgeProps {
  color?: BadgeColor;
  className?: string;
  children?: React.ReactNode;
}

export default function Badge({
  color = 'gray',
  children,
  className,
}: KitBadgeProps) {
  return (
    <Container className={className} color={color}>
      {children}
    </Container>
  );
}

const Container = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: BadgeColor }>(({ theme, color = 'gray' }) => ({
  marginRight: '3px',
  borderRadius: '12px',
  padding: '7px 12px',
  textTransform: 'uppercase',
  fontSize: '10px',
  fontWeight: '600',
  lineHeight: '1',
  color: theme.palette.common.white,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  verticalAlign: 'baseline',
  display: 'inline-block',
  backgroundColor:
    color === 'gray' ? theme.palette.grey[400] : theme.palette[color].main,
}));
